import DataSource from "../DataSource/DataSource";

export default class SamoodpocetService {

  constructor(server, FileService){
    this.server = server;
    this.FileService = FileService;
  }



  /*
   data = [
     {
        kodOM: string,
        cisloMeradla: string,
        datum: Date,
        stavMeradla: integer,
        stavMeradla2: integer,
        typ: string,
     },
     ...
   ];
  */

  submit(data){
    return this.server("samoodpocet.submit", {data: data});
  }

  listSource(){
    return new DataSource(this.server, "samoodpocet.list.source");
  }

  export(){
    return this.server("mail.test");
  }

  readXls(typOM, file){
    return this.FileService.read(file).then(file => this.server("samoodpocet.xls.read", {file: file, typOM: typOM}));
  }

}


// WEBPACK FOOTER //
// ./src/Odpocet/SamoodpocetService.js